import { CinemarkLink } from '@/components/cinemark-link/cinemark-link';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { PromotionalContentPlacement } from '@/enums/promotional-content-placement';
import { dataTestTransformer } from '@/utils/data-test-helper';
import { PromoContent } from '@cinemark/content-api-client';
import { clsx } from 'clsx';
import promotionalTextStyles from './promotional-text.module.scss';

type PromotionalTextProps = {
  className?: string;
  dataLinkCategory: string;
  dataLinkName?: string;
  promoContent: PromoContent;
};

export const PromotionalText = ({ className, dataLinkCategory, dataLinkName, promoContent }: PromotionalTextProps): React.JSX.Element | null => {
  if (!promoContent) {
    return null;
  }

  const lowerPlacement = promoContent.placement?.toLowerCase();
  const removeCardStyle = lowerPlacement !== PromotionalContentPlacement.Sidebar.toLowerCase()
    && lowerPlacement !== PromotionalContentPlacement.MidContent.toLowerCase();

  return (
    <Card className={clsx(removeCardStyle && promotionalTextStyles['promotional-card'], removeCardStyle && promotionalTextStyles['no-background'], className)}>
      {promoContent.promoTitle &&
        <CardHeader>
          <CardTitle dataTest="promo-text-title">{promoContent.promoTitle}</CardTitle>
        </CardHeader>
      }
      <CardContent>
        <p data-test="promo-text-text">{promoContent.promoText}</p>
      </CardContent>
      <CardFooter className="flex justify-end">
        {promoContent.url &&
          <CinemarkLink primary
            dataLinkCategory={dataLinkCategory}
            dataLinkName={dataLinkName || `Promo Text - ${promoContent.altText || 'Details'}`}
            dataTest={`link-${dataTestTransformer(promoContent.altText || 'details')}`}
            href={promoContent.url}
          >
            {promoContent.altText || 'Details'}
          </CinemarkLink>
        }
      </CardFooter>
    </Card>
  );
};
